import { createSlice } from '@reduxjs/toolkit';

import { serviceProfile as jsonServiceProfile } from '@/profile/serviceProfile';
import type { ServiceProfile } from '@/profile/type';

export interface ServiceProfileState {
  serviceProfile: ServiceProfile;
}

const initialState: ServiceProfileState = {
  serviceProfile: jsonServiceProfile,
};

export const serviceProfileSlice = createSlice({
  name: 'serviceProfile',
  initialState,
  reducers: {
    setServiceProfile: (state, { payload }) => {
      state.serviceProfile = payload;
    },
  },
});

export const {
  reducer: serviceProfileReducer,
  actions: { setServiceProfile },
} = serviceProfileSlice;
